import { cn } from '@/lib/utils'

type EvalDetailState = 'loading' | 'error' | 'empty' | 'not-found'

interface EvalDetailStatePanelProps {
  state: EvalDetailState
  label: string
  heading?: boolean
  className?: string
}

const stateClassNames: Record<EvalDetailState, string> = {
  loading: 'border-gray-200 bg-white text-neutral-low-contrast',
  error: 'border-red-200 bg-red-50 text-red-700',
  empty: 'border-gray-200 bg-white text-neutral-low-contrast',
  'not-found': 'border-gray-200 bg-white text-primary-high-contrast',
}

export function EvalDetailStatePanel({
  state,
  label,
  heading = false,
  className,
}: EvalDetailStatePanelProps) {
  const role =
    state === 'error' ? 'alert' : state === 'loading' ? 'status' : undefined

  return (
    <div
      role={role}
      className={cn(
        'rounded-lg border px-4 py-6 text-sm',
        stateClassNames[state],
        className
      )}>
      {heading ? (
        <h1 className="text-lg font-semibold">{label}</h1>
      ) : (
        <p>{label}</p>
      )}
    </div>
  )
}
